var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"scroll-to-top"},[_c('i',{staticClass:"icon wb-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }